import { createContext } from 'react';
import { useRSimsSims } from 'rSimInventory/hooks/useRSimsSims';

type RSimsSimsMap = ReturnType<typeof useRSimsSims>;

export const rSimsSimsContext = createContext<{ data: RSimsSimsMap }>({ data: {} as RSimsSimsMap });
